import { Link } from "@tanstack/react-router";
import { ArrowRight, MapPin } from "lucide-react";
import { neighborhoodPages, type NeighborhoodPage } from "@/data/neighborhoodPages";

type Props = {
  service: NeighborhoodPage["service"];
  heading: string;
  subheading?: string;
};

export function NeighborhoodLinks({ service, heading, subheading }: Props) {
  const pages = neighborhoodPages.filter((p) => p.service === service);
  if (pages.length === 0) return null;
  return (
    <section className="border-t border-border bg-card/30">
      <div className="container mx-auto px-6 py-16">
        <h2 className="font-display text-3xl md:text-4xl font-bold">{heading}</h2>
        {subheading && (
          <p className="mt-3 text-muted-foreground max-w-2xl">{subheading}</p>
        )}
        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {pages.map((p) => (
            <Link
              key={p.to}
              to={p.to}
              className="card-elegant sheen group rounded-xl border border-border bg-card p-5 shadow-card hover:border-brand/50 hover:shadow-glow"
            >
              <div className="flex items-center gap-2 text-xs uppercase tracking-wide text-muted-foreground">
                <MapPin className="h-3.5 w-3.5" /> {p.neighborhoodName}
              </div>
              <h3 className="mt-2 font-display text-lg font-semibold group-hover:text-brand-text">
                {p.label}
              </h3>
              <span className="mt-3 inline-flex items-center gap-1 text-sm text-brand-text">
                Explore <ArrowRight className="h-3.5 w-3.5" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
